import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import useResizeObserver from 'use-resize-observer'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Feature/Hero'
import ArticleCard from '@/components/Articles/Card'
import { useResizer } from '../contexts/Resizer'

import { useStaticQuery, graphql } from 'gatsby'

let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const IndexPage = () => {
  const { ref, width, height } = useResizeObserver()
  const setArea = useResizer()

  const data = useStaticQuery(graphql`
    query mgposts($fields: [WpPostFieldsEnum] = date) {
      allWpPost(
        filter: {
          categories: { nodes: { elemMatch: { name: { eq: "MG HS Trophy" } } } }
        }
        sort: { fields: $fields, order: DESC }
      ) {
        edges {
          node {
            slug
            title
            excerpt
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, quality: 90)
                  }
                }
              }
            }
            postFormats {
              nodes {
                name
              }
            }
            date
          }
        }
      }
    }
  `)

  // console.log(typeof setArea, setArea)

  useEffect(() => {
    console.log(setArea, width, height)
    if (setArea) {
      console.log('setArea is finally setted!')
      let timeout = setTimeout(() => {
        setArea(area => {
          if (area.width !== width || area.height !== height) {
            return { width, height }
          } else {
            return area
          }
        })
      }, 150)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [width, height, setArea])

  return (
    <motion.div
      ref={ref}
      initial="exit"
      animate="enter"
      exit="exit"
      variants={animations}>
      <Layout>
        <SEO title="Todos los frentes de MG" />
        <Hero
          titleLine1="Todos los <span>frentes</span> de"
          titleLine2="MG"
          subtitle="Un embajador que refleja el ADN de la marca, la evolución de los SUV y la estrategia para expandirse por el mundo. Esas son algunas de las tácticas de MG para posicionarse como una de las firmas más exitosas del orbe en el último tiempo."></Hero>

        {/* {Articles.map(article => (
        <ArticleCard key={article.title} {...article} />
      ))} */}
        {data.allWpPost.edges.map((edge, index) => (
          <ArticleCard
            key={edge.node.slug}
            odd={index % 2 === 0}
            title={edge.node.title}
            excerpt={edge.node.excerpt}
            slug={edge.node.slug}
            featuredImage={edge.node.featuredImage}
            type={
              edge.node.postFormats?.nodes[0]?.name === 'Video'
                ? 'video'
                : 'article'
            }
          />
        ))}
      </Layout>
    </motion.div>
  )
}

export default IndexPage
